var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconError48Line = function SvgIconError48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.999 40.7a16.7 16.7 0 1 1 16.7-16.7 16.72 16.72 0 0 1-16.7 16.7Zm0-30a13.3 13.3 0 1 0 13.3 13.3 13.32 13.32 0 0 0-13.3-13.3Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.699 15.75h-3.4v10.5h3.4v-10.5ZM25.699 29.25h-3.4v3h3.4v-3Z",
    fill: "current"
  })));
};
export default SvgIconError48Line;